import { RR_TABLE_PAGINATION_POSITION } from '../../enum/table/position.enum';
import { RRIPagination } from '../base-pagination.interface';
import { RRISettings } from '../base-settings.interface';

export interface RRITablePaginationSettings
  extends RRISettings<RR_TABLE_PAGINATION_POSITION, RRIPagination> {
  showItemsPerPageOn: RR_TABLE_PAGINATION_POSITION;
}
